import './index.scss';
import React, { ReactNode } from 'react';

import { cn } from '@/util/ui';

type StatusIndicatorProps = {
  status: string;
  className?: string;
  children?: ReactNode;
};

const StatusIndicator = ({
  status,
  className,
  children,
}: StatusIndicatorProps) => {
  const formattedClassName = (status || '').replace(/\s+/g, '-').toLowerCase();

  return (
    <div className={cn(`taskStatus`, formattedClassName, className)}>
      {children}
      <span>{status !== 'In Progress' ? status : 'Active'}</span>
    </div>
  );
};

StatusIndicator.defaultProps = {
  status: '',
};

export default StatusIndicator;
